import { OPEN_DATA, BIS, COMBINED } from 'data/dataSourceConstants';
import OutboundLink from 'components/OutboundLink';
import { API_URL } from 'data/services/apiConstants';

function AEULink({ violationNumber, formType, dataSource, rowData }) {
	// different pdf urls for OpenData vs BIS. If using combined data, prefer BIS and fallback to OpenData
	let useBis = dataSource === BIS;
	let useOpenData = dataSource === OPEN_DATA;

	if (dataSource === COMBINED) {
		if (rowData?.bisEcbViolationNumber) {
			//bisEcbViolationNumber is the violation number from bis on the combined dataset
			useBis = true;
		} else if (rowData?.odEcbViolationNumber) {
			//odEcbViolationNumber is the violation number from opendata on the combined dataset
			useOpenData = true;
		}
	}

	let url = '';
	if (useBis) {
		url = `${API_URL}/api/ecb-violations/${violationNumber}/${formType}`;
	} else if (useOpenData) {
		url = `${API_URL}/api/open-data/ecb-violations/${violationNumber}/${formType}`;
	} else {
		return '-';
	}
	
	return <OutboundLink url={url} iconOnly />;
}

export const AEU2Link = (props) => {
	return AEULink({
		violationNumber: props.text,
		formType: 'aeu2',
		dataSource: props.dataSource,
		rowData: props.rowData,
	});
};

export const AEU20Link = (props) => {
	return AEULink({
		violationNumber: props.text,
		formType: 'aeu20',
		dataSource: props.dataSource,
		rowData: props.rowData,
	});
};
